import React, { createContext, useContext, useState, useCallback } from 'react';

interface PricingState {
  isUpgradeModalOpen: boolean;
  source: string;
  plan: string;
}

interface PricingContextType {
  state: PricingState;
  openUpgradeModal: (source?: string, plan?: string) => void;
  closeUpgradeModal: () => void;
}

const PricingContext = createContext<PricingContextType | null>(null);

export const PricingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<PricingState>({
    isUpgradeModalOpen: false,
    source: '',
    plan: '',
  });

  const openUpgradeModal = useCallback((source = '', plan = '') => {
    setState({ isUpgradeModalOpen: true, source, plan });
  }, []);

  const closeUpgradeModal = useCallback(() => {
    setState(prev => ({ ...prev, isUpgradeModalOpen: false }));
  }, []);

  return (
    <PricingContext.Provider value={{ state, openUpgradeModal, closeUpgradeModal }}>
      {children}
    </PricingContext.Provider>
  );
};

export const usePricing = () => {
  const context = useContext(PricingContext);
  if (!context) throw new Error('usePricing must be used within PricingProvider');
  return context;
};
